import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/version';

const initialState = fromJS({
  data: [],
  state: null,
  exemption: {
    data: [],
    state: null,
  },
  taxRate: {
    data: {},
    state: null,
  },
});

const VersionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.VERSIONS_FETCH_START: {
      return state.set('state', fetchingState.FETCHING);
    }
    case actions.VERSIONS_FETCH_ERROR: {
      return state.set('state', fetchingState.ERROR);
    }
    case actions.VERSIONS_FETCH_SUCCESS: {
      return state
        .set('state', fetchingState.LOADED)
        .set('data', fromJS(_.get(action, 'data.results', [])));
    }

    case actions.VERSION_EXEMPTIONS_FETCH_START: {
      return state.setIn(['exemption', 'state'], fetchingState.FETCHING);
    }
    case actions.VERSION_EXEMPTIONS_FETCH_ERROR: {
      return state.setIn(['exemption', 'state'], fetchingState.ERROR);
    }
    case actions.VERSION_EXEMPTIONS_FETCH_SUCCESS: {
      return state
        .setIn(['exemption', 'state'], fetchingState.LOADED)
        .setIn(
          ['exemption', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case actions.VERSION_TAX_RATES_FETCH_START:
    case actions.UPDATE_VERSION_TAX_RATE_START: {
      return state.setIn(['taxRate', 'state'], fetchingState.FETCHING);
    }
    case actions.VERSION_TAX_RATES_FETCH_ERROR:
    case actions.UPDATE_VERSION_TAX_RATE_ERROR: {
      return state.setIn(['taxRate', 'state'], fetchingState.ERROR);
    }
    case actions.VERSION_TAX_RATES_FETCH_SUCCESS:
    case actions.UPDATE_VERSION_TAX_RATE_SUCCESS: {
      return state
        .setIn(['taxRate', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxRate', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }

    default: {
      return state;
    }
  }
};

export default VersionReducer;
